const accessibilityAriaEnum = {
    accessibilityDescription: "aria-label",
    accessibilityDescriptionElementId: "aria-labelledby",
    accessibilitySubDescriptionElementId: "aria-describedby",
    accessibilityExpanded: "aria-expanded",
}

export default accessibilityAriaEnum;